import React from "react";
import styled, {css} from "styled-components";

const GanttButton = ({handleOpen, isSelected}) => {

    return (
        <Button $mode={isSelected} onClick={handleOpen}>
            <p> Gantt </p>
        </Button>
    )
}


const Button = styled.button`
  border: none;
  padding: 0.5rem 1rem;
  border-top: 1px solid var(--color-purple);
  border-bottom-left-radius: 5px ;
  border-top-left-radius: 5px ;

  border-bottom: 1px solid var(--color-purple);
  border-left: 1px solid var(--color-purple);
  cursor: pointer;

  p {
    color: var(--color-purple);
    text-transform: uppercase;
    font-weight: 700;
  }

  &:hover {
    background-color: var(--color-purple-lighten);
    p{
      color: var(--color-purple);
    }
  }

  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          background-color: var(--color-purple);

          p {
            color: var(--color-white)
          }
        `;
      default:
        return css`
          background-color: transparent;

        `;
    }
  }}
`
export default GanttButton